export function isValidUserLoggedIn({ accessToken, tokenExpiration }) {
  const isThereAnAccessToken = accessToken !== null
  const isTokenExpired = new Date(tokenExpiration ?? "") <= new Date(Date.now())
  return isThereAnAccessToken && !isTokenExpired
}
